export * from './BasicLayout';
export * from './FullPageLayout';
import * as React from 'react';
import { BasicLayout } from './BasicLayout';
import { FullPageLayout } from './FullPageLayout';

export type Layout = 'BasicLayout' | 'FullPageLayout';

export const layouts: Record<Layout, React.ReactNode> = {
  BasicLayout: <BasicLayout />,
  FullPageLayout: <FullPageLayout />,
};
